import { useEffect, useState } from 'react'
import { Box } from '@mui/system'
import { useI18n } from '@ggs/i18n'
import { useLocationApi } from '../../../local'
import { useSelector } from '@ggs/store'
import { keyBy } from 'lodash'
import { Loader } from '../../loader'
import campusContact from './campusContact.json'

/**
 * @typedef {Object} CampusLocationRel
 * @property {string} campusId
 * @property {string} adminBuildingId
 */

/**
 * @typedef {Object} CampusContact
 * @property {string} url
 */

/**
 * @typedef {import('../../../definitions').BuildingRecord} BuildingRecord
 * @typedef {import('lodash').Dictionary<CampusLocationRel>} CampusLocationRelDict
 * @typedef {import('lodash').Dictionary<CampusContact>} CampusesIndex
 */

/**
 * Display currently selected campus details.
 *
 * @return {JSX.Element}
 */
const CurrentCampusView = () => {
  const { t } = useI18n()
  const [loading, setLoading] = useState(true)

  /**
   * @type {CampusesIndex}
   */
  const defaultCampusesIndex = null
  const [campusesIndex, setCampusesIndex] = useState(defaultCampusesIndex)
  const campus = useSelector((state) => state.settings.campus)
  const defaultCampusId = 'CAM1'

  /**
   * Resolve campus information.
   */
  const resolveData = async () => {
    setCampusesIndex(campusContact)
    setLoading(false)
  }

  useEffect(() => {
    resolveData().then(() => {})
  }, [])

  if (!campusesIndex || loading) {
    return <Loader />
  }

  const currentCampus = campusesIndex[campus] || campusesIndex[defaultCampusId]
  if (!currentCampus) {
    return null
  }

  return (
    <Box>
      <div className="o-page-footer__info">
        <div>
          <b>{t('Vancouver | Kelowna, BC Canada')}</b>
        </div>
        <div>
          <a href={currentCampus.url}>{t('Contact Us')}</a>
        </div>
      </div>
    </Box>
  )
}

export default CurrentCampusView
